/* eslint-disable no-magic-numbers */
/* eslint-disable no-unused-vars */
/* global $, FullCalendar, FullCalendarICalendar*/
import { initMiniListView } from '../CM.Calendar/scripts/Custom_fullCalendar/miniListViewConfig.mjs';

export function init(options) {
	const {
		calendarElement,
		CalendarId,
		Events,
		CalendarApiKey,
		CalendarSources,
		_eventBubble,
		_limitVisibleEvents,
		_noEventMessage,
		_popupBackgroundColor,
		_popupLinkColor,
		_timeZone,
		_timeZoneCustom,
		_dateformat,
		_dateformatWeekday,
		_dateformatDay,
		_dateformatDivider,
		_dateformatMonth,
		_dateformatYear,
		_saperator,
		_timeformat,
		_timeformatHours,
		_timeformatDivider,
		_timeformatMinutes,
		_timeformatMeridieum,
		_weekstartOn,
		_weekstartOnCustom,
		_calendarView,
		_calendarstartdefault,
		_upcomingEventLimit,
		_earliestEvent,
		_earliestEventRange,
		_latestEvent,
		_latestEventRange,
	} = options;

	if (_calendarView === '3') {
		// remove margin on header toolbar when the view is upcoming list
		// create a style sheet to insert rules
		const toolbarElement = document.createElement('style');

		// Append style element to head
		document.head.appendChild(toolbarElement);

		const toolbarSheet = toolbarElement.sheet;

		toolbarSheet.insertRule(
			'.fc .fc-toolbar.fc-header-toolbar{ margin-bottom: 0;}',
			0
		);
		// remove margin-left on upcomingEventsList
		toolbarSheet.insertRule('#upcomingEventsList{margin-left: 0;}', 1);
	}

	// get users selected time format
	function getTimeFormatMeridiem() {
		// set meridiem Ex: PM vs pm
		if (_timeformat === '2') {
			if (_timeformatMeridieum === 'a') {
				return 'short';
			}
			return 'short'.toUpperCase();
		}
		return 'short'.toUpperCase();
	}
	function getTimeFormatMinute() {
		// set minutes to use a numeric or 2-digit representation.
		if (_timeformat === '2') {
			if (_timeformatMinutes === 'm') {
				return 'numeric';
			}
			return '2-digit';
		}
		return 'numeric';
	}
	function getTimeFormatHour() {
		// set hours to use a numeric or 2-digit representation. Ex: 1:30 vs 01:30
		let hourFormat;
		if (_timeformat === '2') {
			if (_timeformatHours === 'h' || _timeformatHours === 'hh') {
				hourFormat = 'numeric';
			} else if (_timeformatHours === 'H' || _timeformatHours === 'HH') {
				hourFormat = '2-digit';
			}
			return hourFormat;
		}
		return 'numeric';
	}
	function getTimeFormatHour12() {
		// sets the calendar to use a 12 or 24-hour format
		let hour12Format;
		if (_timeformat === '2') {
			if (_timeformatHours === 'h' || _timeformatHours === 'hh') {
				hour12Format = true;
			} else if (_timeformatHours === 'H' || _timeformatHours === 'HH') {
				hour12Format = false;
			}
			return hour12Format;
		}
		return true;
	}
	// get users selected view
	function getInitialView() {
		// checks the calendar view selected by the user and returns the corresponding view
		let initialView;
		switch (_calendarView) {
			case '1':
				initialView = 'dayGridMonth';
				break;
			case '2':
				initialView = 'listMonth';
				break;
			case '3':
				initialView = 'miniListWeek'; // miniListWeek custom view
				// let calendar = document.getElementById(`${calendarElement.id}`);
				// calendar.classList.add('fc-shrink');
				break;
			case '4':
				initialView = 'dayGridMonth'; // Full Width with toggles
				break;
			default:
				initialView = 'dayGridMonth';
				break;
		}
		return initialView;
	}
	function getHeader() {
		// checks the calendar view selected by the user and returns a header object
		if (_calendarView === '4') {
			// Full Width With Toggles
			return {
				left: 'prev,next today',
				center: 'title',
				right: 'dayGridMonth,dayGridWeek,dayGridDay,listMonth',
			};
		} else if (_calendarView === '3') {
			// Upcoming Events View
			return { left: '', center: '', right: '' };
		}
		return { left: 'prev today', center: 'title', right: 'next' };
	}
	function formatDateOptions() {
		// returns a config object for the FullCalendar.formatDate method
		let _dateformatMonthType;
		switch (
			_dateformatMonth // checks selected month type and assigns it to _dateformatMonthType
		) {
			case 'MMM':
				_dateformatMonthType = 'short';
				break;
			case 'MM':
				_dateformatMonthType = '2-digit';
				break;
			case 'M':
				_dateformatMonthType = 'numeric';
				break;
			default:
				_dateformatMonthType = 'long';
		}

		if (_dateformat === '1') {
			// defaults for date format
			return {
				month: 'long',
				year: 'numeric',
				day: 'numeric',
				hour: getTimeFormatHour(),
				hour12: getTimeFormatHour12(),
				minute: getTimeFormatMinute(),
				meridiem: getTimeFormatMeridiem(),
				timeZone:
					_timeZone.toString() === '2' ? `${_timeZoneCustom}` : '',
			};
		}
		return {
			// custom options for date format
			month: _dateformatMonthType,
			year: _dateformatYear === 'YYYY' ? 'numeric' : '2-digit',
			day: _dateformatDay === 'DD' ? '2-digit' : 'numeric',
			hour: getTimeFormatHour(),
			hour12: getTimeFormatHour12(),
			minute: getTimeFormatMinute(),
			meridiem: getTimeFormatMeridiem(),
			timeZone: _timeZone.toString() === '2' ? `${_timeZoneCustom}` : '',
		};
	}
	function injectSeparator(str) {
		// replaces the comma separating the date and time with the user selected separator
		const lastCommaIndex = str.lastIndexOf(',');
		return `${str.substring(
			0,
			lastCommaIndex
		)} ${_saperator} ${str.substring(lastCommaIndex + 1)}`;
	}
	function setEarliestEvent() {
		let startDate = new Date(_calendarstartdefault);
		switch (parseInt(_earliestEvent, 10)) {
			case 0: // provides an empty string to the validRange start value - shows all events prior to start date
				startDate = '';
				break;
			case 1: // sets the earliest event displayed to todays date
				startDate = _calendarstartdefault;
				break;
			case 2: // sets the earliest event displayed to '_earliestEventRange' days before todays date.
				startDate = startDate.setDate(
					startDate.getDate() + 1 - _earliestEventRange
				);
				break;
			case 3: // sets the earliest event displayed to '_earliestEventRange' weeks before todays date.
				startDate = startDate.setDate(
					startDate.getDate() + 1 - _earliestEventRange * 7
				);
				break;
			case 4: // sets the earliest event displayed to '_earliestEventRange' months before todays date.
				startDate = startDate.setDate(
					startDate.getDate() + 1 - _earliestEventRange * 30
				);
				break;
			case 5: // sets the earliest event displayed to '_earliestEventRange' years before todays date.
				startDate = startDate.setDate(
					startDate.getDate() + 1 - _earliestEventRange * 365
				);
				break;
			default:
				break;
		}
		return startDate;
	}
	function setLatestEvent() {
		let endDate = new Date(_calendarstartdefault);
		switch (parseInt(_latestEvent, 10)) {
			case 0: // provides an empty string to the validRange end value - shows all events after the start date
				endDate = '';
				break;
			case 1: // sets the latest event displayed to todays date - will display the entire day
				endDate = endDate.setDate(endDate.getDate() + 1);
				break;
			case 2: // sets the earliest event displayed to '_latestEventRange' days before todays date.
				endDate = endDate.setDate(
					endDate.getDate() + 1 + _latestEventRange
				);
				break;
			case 3: // sets the earliest event displayed to '_latestEventRange' weeks before todays date.
				endDate = endDate.setDate(
					endDate.getDate() + 1 + _latestEventRange * 7
				);
				break;
			case 4: // sets the earliest event displayed to '_latestEventRange' months before todays date.
				endDate = endDate.setDate(
					endDate.getDate() + 1 + _latestEventRange * 30
				);
				break;
			case 5: // sets the earliest event displayed to '_latestEventRange' years before todays date.
				endDate = endDate.setDate(
					endDate.getDate() + 1 + _latestEventRange * 365
				);
				break;
			default:
				break;
		}
		return endDate;
	}
	function createEventSources() {
		const eventSources = [];
		CalendarSources.forEach((source) => {
			if (source.CalendarTypeId.toString() === '1') {
				eventSources.push({
					googleCalendarId: `${source.Source}`,
					googleCalendarApiKey: `${source.GoogleCalendarApiKey}`,
					color: `${source.Color}`,
					className: `source-${source.Id}`,
				});
			} else {
				eventSources.push({
					url: source.Source,
					format: 'ics',
					color: `${source.Color}`,
					className: `source-${source.Id}`,
				});
			}
		});
		return eventSources;
	}
	function createSourcesStylesheet() {
		// creates a style sheet and inserts rules for each source added.
		const sourcesElement = document.createElement('style');

		// Append style element to head
		document.head.appendChild(sourcesElement);

		const sourcesSheet = sourcesElement.sheet;

		CalendarSources.forEach((source, ind) => {
			const styles = `.source-${source.Id} {color: ${source.Color} !important;}`;
			sourcesSheet.insertRule(styles, ind);
		});
	}

	const calendarEventSources = createEventSources();

	// Tooltip for showing calendar event descriptions
	const tooltipContainer = `<div id="dvToolTipContainer" class="tooltipevent" style="display:none; width:250px;font-size: 12px;line-height: 1.4;background:#ccc;position:absolute;z-index:10001;text-align: left;padding: 10px;background-color:${_popupBackgroundColor};border-radius: 3px;box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);right: -4px;color: #FFF;opacity: 1.9;overflow: auto"></div>`;
	document.body.insertAdjacentHTML('beforeend', tooltipContainer);
	const tooltipInner = document.getElementById('dvToolTipContainer'); // used to set the innerHtml

	let expanded = false;
	function showCheckboxes() {
		const checkboxes = document.getElementById('checkboxes');
		if (!expanded) {
			checkboxes.style.display = 'block';
			expanded = true;
		} else {
			checkboxes.style.display = 'none';
			expanded = false;
		}
	}

	const calendarDropdown = document.createElement('div');
	calendarDropdown.classList.add('multiselect');

	// check boxes
	const checkBoxes = document.createElement('div');
	checkBoxes.id = 'checkboxes';

	calendarDropdown.appendChild(checkBoxes);

	// functions for eventClick && Upcoming Events
	function eventClickedURL(url) {
		// if the events url is not empty provide an anchor tag redirecting them to the url
		return url !== ''
			? `<a href="#" class="toolTipMore"style="color:${_popupLinkColor};" onclick="window.open('${url}', 'eventwindow', 'width=700,height=600')">More Details</a>`
			: '';
	}
	function eventClickedDescription(description) {
		// returns a string of the events description. If empty returns 'No description'
		return description !== 'undefined' && description !== undefined
			? `${description}`
			: 'No description';
	}
	function eventClickedStartDate(startDate) {
		// formats and returns the clicked start date
		if (startDate) {
			let formatedStartDate = FullCalendar.formatDate(
				startDate,
				formatDateOptions()
			);

			formatedStartDate = injectSeparator(formatedStartDate);
			return formatedStartDate;
		}
		return '';
	}
	function eventClickedEndDate(endDate) {
		// formats and returns the clicked end date
		if (endDate) {
			let formatedEndDate = FullCalendar.formatDate(
				endDate,
				formatDateOptions()
			);

			formatedEndDate = injectSeparator(formatedEndDate);
			return formatedEndDate;
		}
		return '';
	}
	function eventClickedTooltip(
		title,
		startDate,
		endDate,
		description,
		url,
		pageY,
		pageX
	) {
		// creates the tooltip that will be displayed when a user clicks an event.
		const tooltip = `<div class="toolTipContainer"><span class="toolTipTitle">${
			title !== 'undefined' ? title : 'Busy'
		}</span><br><br> <span class="toolTipDates">${eventClickedStartDate(
			startDate
		)} ${
			_dateformatDivider ? _dateformatDivider : '-'
		}<br> ${eventClickedEndDate(
			endDate
		)} </span><br><br> <p class="toolTipDescription">${eventClickedDescription(
			description
		)} </p><br><br>
		${eventClickedURL(url)}</div>`;

		tooltipInner.innerHTML = tooltip;
		tooltipInner.style.display = 'block';
		tooltipInner.style.top = `${pageY + 10}px`;
		tooltipInner.style.left = `${pageX - 100}px`;
	}

	// init miniListView custom view - Upcoming Events
	const miniListViewConfig = initMiniListView(
		FullCalendar,
		_calendarstartdefault,
		_upcomingEventLimit,
		_timeZone,
		_timeZoneCustom
	);

	// init FullCalendar
	const calendar = new FullCalendar.Calendar(calendarElement, {
		height: 'auto',
		timeZone: _timeZone.toString() === '2' ? `${_timeZoneCustom}` : '',
		initialView: getInitialView(),
		initialDate: `${_calendarstartdefault}`,
		firstDay:
			_weekstartOnCustom !== '' ? parseInt(_weekstartOnCustom, 10) : 0, // -- Which day the calendar will start on Ex: 4 = Thursday
		headerToolbar: getHeader(),
		dayMaxEventRows: true,
		eventSources: calendarEventSources,
		views: {
			dayGridDay: {
				dayMaxEventRows: false,
				displayEventTime: true,
			},
			dayGridWeek: {
				dayMaxEventRows: _limitVisibleEvents,
			},
			dayGridMonth: {
				dayMaxEventRows: _limitVisibleEvents,
			},
			listMonth: {
				validRange: {
					start: setEarliestEvent(), // events before start date
					end: setLatestEvent(), // events after start date
				},
			},
			miniListWeek: miniListViewConfig, // Upcoming Events custom view
		},
		displayEventTime: true,
		eventClick(info) {
			if (_eventBubble === '0' || _eventBubble === '1') {
				info.jsEvent.preventDefault();

				// displays the tooltip for the clicked event and passes all necessary arguments
				eventClickedTooltip(
					info.event.title,
					info.event.start,
					info.event.end,
					info.event.extendedProps.description,
					info.event.url,
					info.jsEvent.pageY,
					info.jsEvent.pageX
				);
			}
		},
		eventContent(event) {
			const eventTitleDiv = document.createElement('div');
			eventTitleDiv.classList.add('fc-event-title');
			const eventTimeDiv = document.createElement('div');
			eventTimeDiv.classList.add('fc-event-time');
			//event title
			eventTitleDiv.innerHTML =
				event.event.title === 'undefined' ? 'Busy' : event.event.title;
			// event time
			eventTimeDiv.innerHTML = event.timeText;

			if (event.view.type === 'listMonth') {
				const anchorTag = document.createElement('a');
				anchorTag.setAttribute('href', `${event.event._def.url}`);
				anchorTag.innerHTML =
					event.event.title === 'undefined'
						? 'Busy'
						: event.event.title;
				return { domNodes: [anchorTag] };
			}
			return { domNodes: [eventTimeDiv, eventTitleDiv] };
		},
		loading(bool) {
			const loading = document.getElementById('loading');
			if (bool) {
				loading.setAttribute('display', 'block');
				createEventSources();
			} else {
				loading.setAttribute('display', 'none');

				// Add calendar sources drop down to DOM IF sources > 1
				const headerElement =
					document.getElementsByClassName('fc-header-toolbar');
				if (calendarEventSources.length > 1 && _calendarView !== '3') {
					headerElement[0].after(calendarDropdown);
				}
			}
		},
		windowResize(view) {
			const todayBtn = document.getElementsByClassName('fc-today-button');
			const toggles = document.getElementsByClassName('fc-toolbar-chunk');

			if (window.innerWidth < 768) {
				if (_calendarView === '1' || _calendarView === '4') {
					calendar.changeView('listMonth');
					// if the user selected calendar view is set to '1'/Month the Tabs will be shown. These should display none on the list view/smaller screens.
					todayBtn[0].style.display = 'none';
					toggles[2].style.display = 'none';
				}
			} else if (
				(_calendarView === '1' || _calendarView === '4') &&
				window.innerWidth >= 768
			) {
				// if default view is not list view - widths higher than 768 will display dayGridMonth view
				calendar.changeView('dayGridMonth');
				todayBtn[0].style.display = 'initial';
				toggles[2].style.display = 'initial';
			}
		},
	});

	function removeCalendarSource(source) {
		const events = calendar.getEventSources();
		events.forEach((event) => {
			// identify right source to remove
			if (source.CalendarTypeId.toString() === '1') {
				if (
					source.Source ===
					event.internalEventSource.meta.googleCalendarId
				) {
					event.remove();
				}
			} else if (source.CalendarTypeId.toString() === '2') {
				if (source.Source === event.internalEventSource.meta.url) {
					event.remove();
				}
			}
		});
		// refetch
		calendar.getEventSources.refetch();
	}

	function addCalendarSource(source) {
		if (source.CalendarTypeId.toString() === '1') {
			calendar.addEventSource({
				googleCalendarId: `${source.Source}`,
				googleCalendarApiKey: `${source.GoogleCalendarApiKey}`,
				color: `${source.Color}`,
				className: `source-${source.Id}`,
			});
		} else {
			calendar.addEventSource({
				url: source.Source,
				format: 'ics',
				color: `${source.Color}`,
				className: `source-${source.Id}`,
			});
		}
		// refetch
		calendar.getEventSources.refetch();
	}

	function handleSourceChange(e, source) {
		if (e.target.checked === true) {
			addCalendarSource(source);
		} else {
			removeCalendarSource(source);
		}
	}

	function toggleCheckboxColor(e, source, sourceCustomCheckbox) {
		if (e.target.checked === true) {
			sourceCustomCheckbox.style.backgroundColor = source.Color;
		} else {
			sourceCustomCheckbox.style.backgroundColor = '#ffffff';
		}
	}

	// add select items for each source
	CalendarSources.forEach((source) => {
		const sourceItem = document.createElement('div');
		sourceItem.classList.add('sourceItem');
		const sourceLabel = document.createElement('label');
		sourceLabel.htmlFor = source.Source;
		sourceLabel.innerText = source.DisplayName;
		sourceItem.appendChild(sourceLabel);

		const sourceInput = document.createElement('input');
		sourceInput.type = 'checkbox';
		sourceInput.value = source.Source;
		sourceInput.id = source.Source;
		sourceInput.checked = true;
		sourceInput.style.backgroundColor = source.Color;
		sourceLabel.prepend(sourceInput);

		const sourceCustomCheckbox = document.createElement('div');
		sourceCustomCheckbox.classList.add('customCheckbox');
		sourceCustomCheckbox.style.backgroundColor = source.Color;
		sourceCustomCheckbox.style.borderColor = source.Color;

		sourceLabel.prepend(sourceCustomCheckbox);

		sourceInput.addEventListener('change', (e) => {
			toggleCheckboxColor(e, source, sourceCustomCheckbox);
			handleSourceChange(e, source);
		});
		checkBoxes.appendChild(sourceItem);
	});

	createSourcesStylesheet();
	calendar.render();

	// if the element clicked does not contain the listed class names - set the tooltips display to none
	document.body.addEventListener('click', (e) => {
		if (
			e.target.className.includes('fc-daygrid-event') ||
			e.target.className.includes('fc-event-time') ||
			e.target.className.includes('fc-event-title') ||
			e.target.className.includes('tooltipevent') ||
			e.target.className.includes('fc-list-event') ||
			e.target.className.includes('fc-list-event-title') ||
			// the anchor tag nested within fc-list-event-title - allows the user to click the title directly in the list view to access the tooltip popup
			e.target.parentElement.className === 'fc-list-event-title' ||
			e.target.className.includes('fc-list-event-time') ||
			e.target.className.includes('fc-list-item-title')
		) {
			e.preventDefault();
			return;
		}
		tooltipInner.style.display = 'none';

		// if the event title is clicked in the upcoming events view - pass data to the tooltip for that event
		if (e.target.className.includes('upcomingEventTitle')) {
			// displays the tooltip for the clicked upcoming event and passes all necessary arguments
			eventClickedTooltip(
				e.target.parentElement.children[1].innerText,
				new Date(e.target.parentElement.children[2].innerText),
				new Date(e.target.parentElement.children[3].innerText),
				e.target.parentElement.children[4].innerText,
				e.target.parentElement.children[5].innerText,
				e.pageY,
				e.pageX
			);
		}
	});
}
